<template>
  <b-card no-body class="menu-bg-blue-transparent">
    <b-container
      class="panel-height scroll-Container"
      :style="layersListMaxHeight"
    >
      <!-- Select/Deselect All button -->
      <b-row class="py-2 px-2">
        <b-col>
          <b-button
            class="btn btn-sm btn-dark btn-block"
            id="selectAll"
            @click="toggleAll()"
          >
            <span class="pl-2" v-if="selectAllControl">Deselect All</span>
            <span class="pl-2" v-else>Select All</span>
          </b-button>
        </b-col>
      </b-row>

      <div
        v-for="subCategory in highwayDBcloudSubcategory"
        :key="subCategory"
        class="pb-1"
      >
        <div class="py-2 bg text-center">
          <span v-if="subCategory != undefined">{{ subCategory }}</span>
          <span v-else>{{ deliveryInfo }}</span>
        </div>

        <b-row
          class="pt-1 px-4"
          v-for="layer in grouped[subCategory]"
          :key="layer.name"
          align-v="center"
        >
          <b-col class="col-no-pad">
            <b-button
              class="btn btn-sm"
              @click="$emit('toggleLayerVisibility', layer.name)"
              :variant="getClass(layer.name)"
            >
              {{ layer.name }}
            </b-button>
          </b-col>

          <b-col class="col-no-pad text-right">
            <b-spinner
              v-if="spinnerManager.includes(layer.name)"
              variant="primary"
              small
            ></b-spinner>
            <img :src="layer.legendURL" />
          </b-col>
        </b-row>
      </div>
    </b-container>
  </b-card>
</template>

<style scoped>
.panel-height {
  max-height: 85vh;
  overflow: auto;
  overflow-y: scroll;
}
.bg {
  background-color: #515a62;
  font-weight: bold;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'MMP_HWDB_Layers',
  props: [
    'grouped',
    'spinnerManager',
    'highwayDBcloudSubcategory',
    'mmp_layersObj',
    'highwayDBcloudLayersButtonsCtrl',
    'map',
    'layersListMaxHeight'
  ],
  data() {
    return {
      deliveryDate: null,
      deliveryInfo: null,
      deliveryPartNumber: null,
      selectAllControl: false
    }
  },
  methods: {
    getClass(layerName) {
      let result = this.$parent.$parent.$parent.btnClass(layerName)
      return result
    },
    getDeliveryDateAndPartNumber() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/hwdb/getNewestDelivery/', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getNewestDelivery API Call Error: ' + content.errors)
            } else {
              this.deliveryDate = new Date(content[0].DeliveryDate)
              this.deliveryPartNumber = content[0].PartNumber
              this.deliveryInfo =
                'Delivered ' +
                this.getFormattedDeliveryDate() +
                ' PN ' +
                this.deliveryPartNumber
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getFormattedDeliveryDate() {
      let formattedDeliveryDate =
        this.deliveryDate.getMonth() +
        1 +
        '/' + // Add one since getMonth is 0-indexed
        this.deliveryDate.getDate() +
        '/' +
        this.deliveryDate.getFullYear()
      return formattedDeliveryDate
    },
    toggleAll() {
      this.selectAllControl = !this.selectAllControl
      // If "Select All" was clicked
      if (this.selectAllControl) {
        this.highwayDBcloudLayersButtonsCtrl.forEach(layer => {
          this.$emit('toggleLayerVisibility', layer.name)
          this.$emit('btnClass', layer.name)
        })
      } else {
        // If "Deselect All" was clicked
        this.highwayDBcloudLayersButtonsCtrl.forEach(layer => {
          this.$emit('unloadLayers', layer.name)
          this.$emit('btnClass', layer.name)
        })
      }
    }
  },
  mounted() {
    this.getDeliveryDateAndPartNumber()
    this.$emit('DLLChange')
  },
  updated() {
    this.$emit('DLLChange')
  }
}
</script>
